import React from "react";
import Icon from "../icon/Icon";
import styles from "./ActionButton.module.css";

function ActionButton({ children, iconName, onClick, type = "button" }) {
  return (
    <button className={styles.button} type={type} onClick={onClick}>
      {children}
      {iconName && <Icon name={iconName} className={styles.icon} />}
    </button>
  );
}

export default ActionButton;
